import { useCallback, useMemo, useState } from 'react';
import _ from 'lodash';
import cookie from 'js-cookie';
import { initVisitor } from '@meiqia/utils';

import { getVisitorPageApi, inviteVisitorApi, exportVisitorApi } from './api';
import {
  getVisitor,
  visitorCome,
  visitorOffline,
  endConversation,
  inviteVisitor,
  rejectInvite,
  acceptInvite,
  changeInviteStatus,
  updateVisitorStatus
} from '../../../reducers/visitor';
import { useDispatch } from '../../../react-redux';

const useVisitor = () => {
  // const [visitorLoading, setVisitorLoading] = useState(false);
  const dispatch = useDispatch();

  const handleGetVisitorPages = useCallback(trackId => {
    return getVisitorPageApi(trackId).then(res => {
      const { pages } = res.data;
      if (pages) {
        return _.reverse(_.sortBy(res.data.pages, 'created_on'));
      }
    });
  }, []);

  const handleInviteVisitor = useCallback(({ trackId }) => {
    const type = 'smart_guide';

    return inviteVisitorApi({
      trackId: trackId,
      type,
      entId: cookie.get('_enterprise_id')
    }).then(res => {
      return res;
    });
  }, []);

  const handleExportVisitor = param => exportVisitorApi(param);

  const extraAction = useMemo(() => {
    const actionKeyName = [
      'visitorCome',
      'visitorOffline',
      'endConversation',
      'inviteVisitor',
      'rejectInvite',
      'acceptInvite',
      'changeInviteStatus',
      'updateVisitorStatus'
    ];
    return [
      visitorCome,
      visitorOffline,
      endConversation,
      inviteVisitor,
      rejectInvite,
      acceptInvite,
      changeInviteStatus,
      updateVisitorStatus
    ].reduce((prev, now, index) => {
      return {
        ...prev,
        [actionKeyName[index]]: param => dispatch(now(param))
      };
    }, {});
  }, [dispatch]);

  // const handleGetVisitor = useCallback(params => {
  //   setVisitorLoading(true);
  //   return getVisitorApi(params)
  //     .then(res => {
  //       if (res?.data?.visits) {
  //         const newVisits = res.data.visits;
  //         dispatch(getVisitor(newVisits.map(val => initVisitor(val))));
  //       }
  //     })
  //     .finally(() => {
  //       setVisitorLoading(false);
  //     });
  // }, []);

  return {
    // handleGetVisitor,
    handleGetVisitorPages,
    handleInviteVisitor,
    handleExportVisitor,
    ...extraAction
    // visitorLoading
  };
};

export default useVisitor;
